<template>
    <div class="setRent_formation_box">
        <div class="inform_tit"> 
            <div @click="cancel" class='cancel_box'>
                <i class="el-icon-back myback_icon"></i> Back
            </div>
        </div>
        <div class="inMain_box">
            <div class="informdata_tit">Set Holidays</div>
            <table class="holiday" cellspacing="0" cellpadding="0">
                <thead>
                    <tr>
                        <th>Date</th>
                        <th>Remark</th>
                        <th>Status</th>
                        <th>Operating</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(item, key) in table" :key="key">
                        <td>{{item.date}}</td>
                        <td>{{item.remark}}</td>
                        <td>{{item.status}}</td>
                        <td>
                            <div class="btns">
                                <div class="btn" @click="editHoliday(item)"><i class="el-icon-edit-outline"></i></div>
                                <div class="btn" @click="delHoliday(item.id)" style="color: #D13A90;"><i class="el-icon-delete"></i></div>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
            <div v-if="table.length === 0" class="loading">
                <i v-if="loading && table.length === 0" class="el-icon-loading" style="font-size:20px"></i>
                <div v-if="!loading && table.length === 0">No Data</div>
            </div>
            <div class="add" @click="appendHoliday"><i></i>Add Holidays</div>
        </div>

        <transition name="fade" v-if="showadd">
            <div class="pop-wrp">
                <div class="second-step">
                    <h1>Add Holidays</h1>
                    <el-form :model="ruleForm" label-position="top" :hide-required-asterisk="true" :rules="rules" ref="ruleForm" label-width="100px" class="information-ruleForm">
                        <h2>Date</h2>
                        <div class="holidayChoosetime clear">
                            <div class="date-innr">
                                <el-form-item prop="start">
                                    <!-- <el-date-picker
                                    v-model="ruleForm.start"
                                    type="date"
                                    placeholder="Start Date"
                                    :picker-options="pickerOptions1"
                                    :editable='false'
                                    @change="start">
                                    </el-date-picker> -->
                                    <div class="timeshowBox">
                                        <i class="el-icon-date"></i>
                                        {{showTime1}}</div>
                                    <el-cascader @change="changeTime(1)" class="timeshowBox1" style="z-index:1;width:100%;opacity:0" :options="dateOptions" separator=" " placeholder="" v-model="ruleForm.start"></el-cascader>
                                </el-form-item>
                            </div>
                            <!--<div class="date-innr">
                                <el-form-item prop="end">
                                    <el-date-picker
                                    v-model="ruleForm.end"
                                    align="right"
                                    type="date"
                                    placeholder="End Date"
                                    :picker-options="pickerOptions2"
                                    :editable='false'
                                    @change="end">
                                    </el-date-picker>
                                    <div class="timeshowBox">
                                        <i class="el-icon-date"></i>
                                        {{showTime2}}</div>
                                    <el-cascader @change="changeTime(2)" class="timeshowBox1" style="z-index:1;width:100%;opacity:0" :options="dateOptions" separator=" " placeholder="" v-model="ruleForm.end"></el-cascader>
                                </el-form-item>
                            </div>-->
                        </div>
                        <el-form-item label="Remark" prop="remark">
                            <el-input class="remark" maxlength="30" v-model="ruleForm.remark"></el-input>
                        </el-form-item>
                        <el-form-item label="Status" prop="status">
                            <el-radio-group v-model="ruleForm.status" class="radiostyle">
                                <el-radio :label="0" style="margin-right:280px">Business</el-radio>
                                <el-radio :label="1">Close</el-radio>
                            </el-radio-group>
                        </el-form-item>
                        <el-form-item class="foot_box">
                            <el-button @click="cancelOperate" class="cardCanBtn">Cancel</el-button>
                            <el-button @click="confirm" class="cardConBtn">Add</el-button>
                        </el-form-item>
                    </el-form>
                </div>
            </div>
        </transition>
        
        <transition name="fade" v-if="showEdit">
            <div class="pop-wrp">
                <div class="second-step">
                    <h1>Edit Holidays</h1>
                    <el-form :model="ruleForm" label-position="top" :hide-required-asterisk="true" :rules="rules" ref="ruleForm1" label-width="100px" class="information-ruleForm">
                        <h2>Date</h2>
                        <div class="holidayChoosetime clear">
                            <div class="date-innr">
                                <el-form-item prop="start">
                                    <!-- <el-date-picker
                                    v-model="ruleForm.start"
                                    type="date"
                                    placeholder="Start Date"
                                    :picker-options="pickerOptions1"
                                    :editable='false'
                                    @change="start">
                                    </el-date-picker> -->
                                    <div class="timeshowBox">
                                        <i class="el-icon-date"></i>
                                        {{showTime1}}</div>
                                    <el-cascader @change="changeTime(1)" class="timeshowBox1" style="z-index:1;width:100%;opacity:0" :options="dateOptions" separator=" " placeholder="" v-model="ruleForm.start"></el-cascader>
                                </el-form-item>
                            </div>
                            <!-- <div class="date-innr">
                                <el-form-item prop="end">
                                    <el-date-picker
                                    v-model="ruleForm.end"
                                    align="right"
                                    type="date"
                                    placeholder="End Date"
                                    :picker-options="pickerOptions2"
                                    :editable='false'
                                    @change="end">
                                    </el-date-picker>
                                    <div class="timeshowBox">
                                        <i class="el-icon-date"></i>
                                        {{showTime2}}</div>
                                    <el-cascader @change="changeTime(2)" class="timeshowBox1" style="z-index:1;width:100%;opacity:0" :options="dateOptions" separator=" " placeholder="" v-model="ruleForm.end"></el-cascader>
                                </el-form-item>
                            </div> -->
                        </div>
                        <el-form-item label="Remark" prop="remark">
                            <el-input class="remark" maxlength="30" v-model="ruleForm.remark"></el-input>
                        </el-form-item>
                        <el-form-item label="Status" prop="status">
                            <el-radio-group v-model="ruleForm.status" class="radiostyle">
                                <el-radio :label="0" style="margin-right:280px">Business</el-radio>
                                <el-radio :label="1">Close</el-radio>
                            </el-radio-group>
                        </el-form-item>
                        <el-form-item class="foot_box">
                            <el-button @click="cancelOperate" class="cardCanBtn">Cancel</el-button>
                            <el-button @click="save" class="cardConBtn">Save</el-button>
                        </el-form-item>
                    </el-form>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
import api from '../../api/api'
import dateOptions from '../../utils/time'
import {mapMutations} from 'vuex'
export default {
    data() {
        return {
            dateOptions:dateOptions,
            table: [],
            loading: true,
            showadd: false,
            showEdit: false,
            showTime1:'',
            showTime2:'',
            ruleForm:{
				start: null,
                end: null,
                remark: '',
                status: 0,
                id: null
            },
            rules:{
                start: [{ required: true, message: ' ', trigger: 'change' }],
                end: [{ required: true, message: ' ', trigger: 'change' }],
                remark: [{ required: true, message: ' ', trigger: 'change' }],
                status: [{ required: true, message: ' ', trigger: 'change' }]
            },
            pickerOptions1: {
                disabledDate(time) {
                    return time.getTime() < Date.now();
                }
            },
            pickerOptions2: {
                disabledDate(time) {
                    return time.getTime() < Date.now();
                }
            },
            startTimeStamp: null, // 选中的开始时间戳(用于传给后端)
            endTimeStamp: null, // 选中的结束时间戳(用于传给后端)
        }
    },
    created() {
        /*var nowTime = new Date();
        var offset = nowTime.getTimezoneOffset()/60;
        console.log(offset)*/
        this.getList()
    },
    methods: {
        ...mapMutations(['setFresh']),
        changeTime(key){
            this.getShowTime(key)
        },
        getShowTime(key){
            let M;
            if(key==1){
                M = this.ruleForm.start[0]
            }else{
                M = this.ruleForm.end[0]
            }
            if (M === '01') {
                M = 'Jan'
            } else if (M === '02') {
                M = 'Feb'
            } else if (M === '03') {
                M = 'Mar'
            } else if (M === '04') {
                M = 'Apr'
            } else if (M === '05') {
                M = 'May'
            } else if (M === '06') {
                M = 'Jun'
            } else if (M === '07') {
                M = 'Jul'
            } else if (M === '08') {
                M = 'Aug'
            } else if (M === '09') {
                M = 'Sep'
            } else if (M === '10') {
                M = 'Oct'
            } else if (M === '11') {
                M = 'Nov'
            } else if (M === '12') {
                M = 'Dec'
            }
            if(key==1){
                this.ruleForm.start?this.showTime1 = this.ruleForm.start[1] + ' ' + M:this.showTime1 = ''
            }else{
                this.ruleForm.end?this.showTime2 = this.ruleForm.end[1] + ' ' + M:this.showTime2 = ''
            }
            
        },
        getList() {
            this.loading = true
            this.table = []
            api.queryHoliday({
                callback: (res) => {
                    this.loading = false
                    if(res.data.code == 0){
                        res.data.data.forEach(item => {
                            let start = (item.startDate)
                            let end = (item.endDate)
                            // let start = Utils.formatDateMonthyear4(item.startDate)
                            // let end = Utils.formatDateMonthyear4(item.endDate)
                            let showDate
                            if (start === end) {
                                showDate = start
                            } else {
                                showDate = `${start} - ${end}`
                            }
                            this.table.push({
                                date: showDate,
                                remark: item.remark,
                                status: item.holidaysStatus === 0 ? 'Business' : 'Close',
                                id: item.id,
                                startDate: item.startDate * 1000,
                                endDate: item.endDate * 1000,
                                holidaysStatus: item.holidaysStatus
                            })
                        })
                    } else if (res.data.code == 8902) {
                        sessionStorage.clear()
                        this.$router.push('/login')
                    } else{
                        Utils.alert('', res.data.message, 'error')
                    }
                }
            })
        },
        appendHoliday () {
            this.showadd = true
            this.ruleForm = {
				start: null,
                end: null,
                remark: '',
                status: 0,
                id: null
            }
            this.showTime1 = null
            this.showTime2 = null
        },
        editHoliday (item) {
            this.showEdit = true
            this.ruleForm = {
				start: item.startDate,
                end: item.endDate,
                remark: item.remark,
                status: item.holidaysStatus,
                id: item.id
            }
            // this.startTimeStamp = item.startDate / 1000
            // this.endTimeStamp = item.endDate / 1000
            this.showTime1 = item.date.split('-')[0].trim()
            this.showTime2 = (item.date.split('-')[1]).trim()
        },
        delHoliday (id) {
            Utils.loadings()
            api.deleteHoliday({
                params: id,
                callback: (res) => {
                    Utils.loadings(2)
                    if(res.data.code == 0){
                        this.setFresh({data: true})
                        this.getList()
                        this.showadd = false
                    } else if (res.data.code == 8902) {
                        sessionStorage.clear()
                        this.$router.push('/login')
                    } else{
                        Utils.alert('', res.data.message, 'error')
                    }
                }
            })
        },
        cancelOperate(){
            this.showadd = false
            this.showEdit = false
            // this.ruleForm = {
            //     start: '',
            //     end: '',
            //     remark: '',
            //     status: 0
            // }
        },
        confirm() {
            var that = this
            that.$refs["ruleForm"].validate((valid) => {
                if (valid) {
                    let pat = {
                        // endDate: Utils.isIntNum(this.ruleForm.end)?this.ruleForm.end:Date.parse(new Date(`2020-${this.ruleForm.end[0]}-${this.ruleForm.end[1]}`))/1000,
                        holidaysStatus: that.ruleForm.status,
                        remark: that.ruleForm.remark,
                        // startDate: Utils.isIntNum(this.ruleForm.start)?this.ruleForm.start:Date.parse(new Date(`2020-${this.ruleForm.start[0]}-${this.ruleForm.start[1]}`))/1000
                        endDate:this.showTime1,
                        startDate:this.showTime1,
                    }
                    let start = Date.parse(new Date(`2020-${this.showTime1.split(' ')[1]}-${this.showTime1.split(' ')[0]}`))/1000
                    /*let end = Date.parse(new Date(`2020-${this.showTime2.split(' ')[1]}-${this.showTime2.split(' ')[0]}`))/1000
                    if(start>end){
                        this.$message.error('The start time cannot be greater than the end time')
                        return
                    }*/
                    Utils.loadings()
                    api.addHoliday({
                        params: pat,
                        callback: (res) => {
                            Utils.loadings(2)
                            if(res.data.code == 0){
                                this.setFresh({data: true})
                                this.getList()
                                this.showadd = false
                            } else if (res.data.code == 8902) {
                                sessionStorage.clear()
                                this.$router.push('/login')
                            } else{
                                Utils.alert('', res.data.message, 'error')
                            }
                        }
                    })
                } else {
                    return false;
                }
            });
        },
        save () {
            var that = this
            that.$refs["ruleForm1"].validate((valid) => {
                if (valid) {
                    let pat = {
                        // endDate: Utils.isIntNum(this.ruleForm.end)?this.ruleForm.end:Date.parse(new Date(`2020-${this.ruleForm.end[0]}-${this.ruleForm.end[1]}`))/1000,
                        holidaysStatus: that.ruleForm.status,
                        remark: that.ruleForm.remark,
                        // startDate: Utils.isIntNum(this.ruleForm.start)?this.ruleForm.start:Date.parse(new Date(`2020-${this.ruleForm.start[0]}-${this.ruleForm.start[1]}`))/1000,
                        id: that.ruleForm.id,
                        endDate:this.showTime1,
                        startDate:this.showTime1,
                    }
                    let start = Date.parse(new Date(`2020-${this.showTime1.split(' ')[1]}-${this.showTime1.split(' ')[0]}`))/1000
                    /*let end = Date.parse(new Date(`2020-${this.showTime2.split(' ')[1]}-${this.showTime2.split(' ')[0]}`))/1000
                    if(start>end){
                        this.$message.error('The start time cannot be greater than the end time')
                        return
                    }*/
                    Utils.loadings()
                    api.alterHoliday({
                        params: pat,
                        callback: (res) => {
                            Utils.loadings(2)
                            if(res.data.code == 0){
                                this.setFresh({data: true})
                                this.getList()
                                this.showEdit = false
                            } else if (res.data.code == 8902) {
                                sessionStorage.clear()
                                this.$router.push('/login')
                            } else{
                                Utils.alert('', res.data.message, 'error')
                            }
                        }
                    })
                } else {
                    return false;
                }
            });
        },
        // 选中开始 / 结束时间
        start (e) {
            if(!e){
                this.pickerOptions1 ={}
                return
            }
            this.pickerOptions2 = {
                disabledDate(time) {
                    return time.getTime() <= e.getTime()-1;
                }
            }
            this.startTimeStamp = e.getTime() / 1000
        },
        end (e) {
            if(!e){
                this.pickerOptions2 ={}
                return
            }
            this.pickerOptions1 = {
                disabledDate(time) {
                    return (time.getTime() >= e.getTime()+1) || time.getTime() < Date.now();
                }
            } 
            this.endTimeStamp = (e.getTime() + 86400000) / 1000 - 1
        },
        cancel() {
            this.$router.replace('/setting')
        }
    },
    watch:{
        showEdit(n,o){
            if(!n){
                this.showTime1=''
                this.showTime2=''
                this.ruleForm.remark=''
                this.ruleForm.status=0
                this.ruleForm.start=''
                this.ruleForm.end=''
            }
        },
        showadd(n,o){
            if(!n){
                this.showTime1=''
                this.showTime2=''
                this.ruleForm.remark=''
                this.ruleForm.status=0
                this.ruleForm.start=''
                this.ruleForm.end=''
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.setRent_formation_box{
    position: relative;
    .inform_tit{
        height:76px;
        font-size:14px;
        font-weight:600;
        color:var(--text-color);
        line-height:20px;
        width: 100%;
        background-color: var(--background-color);
        z-index: 100;
        .cancel_box{
            cursor: pointer;
            width: 150px;
        }
    }
    .inMain_box{
        background-color: var(--background-color-4);
        width: 100%;
        box-sizing: border-box;
        padding:50px 30px;
        .informdata_tit{
            text-align: center;
            margin-bottom: 50px;
            height:42px;
            font-size:30px;
            font-family:PingFangSC-Semibold,PingFang SC;
            font-weight:600;
            color:var(--text-color);
            line-height:42px;
        }
        .holiday{
            border: 1px solid #5F5F5F;
            width: 100%;
            background: var(--background-color-2);
            th, td{
                font-family: PingFangSC-Semibold, PingFang SC;
                color: var(--text-color);
                text-align:center;
                box-sizing: border-box;
                line-height: 26px;
                width: 25%;
            }
            th{
                font-size: 16px;
                padding: 14px 10px;
            }
            td{
                font-size: 18px;
                padding: 18px 10px;
                border-top: 1px solid #5F5F5F;
                border-right: 1px solid #5F5F5F;
                :nth-last-child(1){
                    border-right: 0;
                }
            }
            .btns{
                text-align: center;
                .btn{
                    display: inline-block;
                    padding: 0 20px;
                    font-size: 20px;
                    color: var(--text-color);
                    cursor: pointer;
                }
            }
        }
        .add{
            width: 100%;
            height: 60px;
            text-align: center;
            line-height: 60px;
            font-size: 18px;
            font-family: PingFangSC-Semibold, PingFang SC;
            font-weight: 600;
            color: #E83695;
            cursor: pointer;
            box-sizing: border-box;
            border-bottom: 1px solid #5F5F5F;
            border-left: 1px solid #5F5F5F;
            border-right: 1px solid #5F5F5F;
            background: var(--background-color-2);
            i{
                display: inline-block;
                width: 20px;
                height: 20px;
                background-repeat: no-repeat;
                background-position: center center;
                background-size: contain;
                background-image: url('../../assets/r.png');
                margin-right: 6px;
                position:relative;
                top: 3px;
            }
        }
    }
}
.pop-wrp{
    width: 100%;
    position: fixed;
    left: 0;
    top: 0;
    height: 100%;
    background:rgba(33,36,41,.8);
    bottom: 0;
    right: 0;
    z-index: 101;
    h1{
        font-size: 24px;
        line-height: 33px;
        font-weight: 600;
        margin-bottom: 50px;
        color: var(--text-color);
        text-align: center;
    }
    .btns{
        margin: 65px auto 0 auto;
        width: 610px;
        button{
        width:280px;
        height:60px;
        outline: none;
        background: none;
        cursor: pointer;
        font-weight: 600;
        }
        
        .dark{
        border: 2px solid var(--text-color);
        color: var(--text-color);
        font-size: 26px;
        float: left;
        }
        .light{
        border: 2px solid #8E3771;
        color: #8E3771;
        font-size: 26px;
        float: right;
        }
        .usable{
        border: 2px solid #EA3796;
        color: #EA3796;
        }
    }
    .normal{
        transform: rotate(0deg);
        opacity: 1;
        margin-left: -420px;
    }
    .second-step{
        width:840px;
        height:608px;
        background:rgba(43,52,68,1);
        position: absolute;
        left: 50%;
        top: 50%;
        margin: -303px 0 0 -420px;
        box-sizing: border-box;
        padding: 65px 50px 0 50px;
        h2{
            font-size: 14px;
            font-family: SFProText-Regular, SFProText;
            font-weight: 400;
            color: var(--text-color);
            line-height: 16px;
            margin-bottom: 10px;
        }
        .upload-con{
        width: 100%;
        height: 280px;
        background: var(--background-color-2);
        box-sizing: border-box;
        border: 1px solid #5F5F5F;
        position: relative;
        text-align: center;
        .close{
            width: 20px;
            position: absolute;
            height: 20px;
            right: 28px;
            top: 69px;
            background-size: contain;
            background-repeat: no-repeat;
            background-position: center center;
            background-image: url('../../assets/c.png');
            cursor:pointer;
        }
        .icon{
            display: block;
            width: 100%;
            height: 35px;
            background-repeat: no-repeat;
            background-size: contain;
            background-position: center center;
            background-image: url('../../assets/upload.png');
            margin-top: 80px;
            margin-bottom: 30px;
        }
        h3{
            font-size: 20px;
            line-height: 28px;
            text-align: center;
            color: var(--text-color);
            span{
            color: #D13A90;
            }
        }
        .upload-demo{
            position: absolute;
            left: 0;
            top: 0;
            width: 100%;
            bottom: 0;
        }
        .el-icon-loading{
            margin-top: 100px;
            font-size: 30px;
        }
        .file{
            width: 660px;
            height: 120px;
            background: var(--background-color-4);
            position: relative;
            margin: 80px auto 0 auto;
            display:flex;
            flex-direction: row;
            box-sizing: border-box;
            padding: 20px;
            .in{
            width: 80px;
            height: 80px;
            margin-right: 20px;
            background-size: contain;
            background-image: url('../../assets/a.png');
            background-position:center center;
            background-repeat: no-repeat;
            flex: 0 0 auto;
            }
            .text{
            flex: 0 0 auto;
            text-align: left;
            width: 520px;
            .tit{
                width: 100%;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
                word-break: break-all;
                font-size: 24px;
                line-height: 33px;
                margin-bottom: 10px;
                margin-top: 5px;
            }
            .size{
                width: 100%;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
                word-break: break-all;
                font-size: 20px;
                line-height: 28px;
            }
            }
        }
        }
    }
}
.fade-enter-active, .fade-leave-active {
transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
opacity: 0;
}
.holidayChoosetime{
    .date-innr{
        width: 355px;
    }
    .date-innr:nth-child(1){
        float: left;
    }
    .date-innr:nth-child(2){
        float: right;
    }
}
.loading{
    text-align: center;
    line-height: 50px;
    color: var(--text-color);
    border-left: 1px solid #5F5F5F;
    border-right: 1px solid #5F5F5F;
    border-bottom: 1px solid #5F5F5F;
    background: var(--background-color-2);
}
.timeshowBox1{
        .el-input.is-focus{
            border-color: #565758 !important;
        }
        .el-input__inner{
            width: 100%;
            z-index: 10;
            height: 40px;
            padding-left: 30px !important;
            top:1px;
            font-size: 20px;
            color: var(--text-color);
            padding-left: 15px;
            border: 1px solid #565758;
            border-radius: 4px;
            background-color: var(--background-color-3);
            &:hover{
                border: 1px solid #565758 !important;
            }
            &:focus{
                border: 1px solid #565758 !important;
            }
        }
        .el-input__suffix{
            display: none !important;
        }
}
.increaseIcon{
		line-height: 40px;
		font-size: 18px;
		color: var(--text-color);
		&:first-child{
			margin-right: 20px;
		}
		&:last-child{
			margin-left: 20px;
		}
	}
    .timeshowBox{
        position: absolute;
        width: 355px;
        border: 1px solid var(--background-color-4);
        border-radius: 4px;
        z-index: 0;
        height: 38px;
        line-height: 38px;
        top:1px;
        padding-left: 10px;
        font-size: 20px;
        color: var(--text-color);
        left: 0px;
        background-color: var(--background-color-3);
    }
</style>


// WEBPACK FOOTER //
// src/components/setting/holiday.vue